import {isUndefined} from 'lodash';
import React, {FC, PropsWithChildren, ReactNode} from 'react';
import styled from 'styled-components';

import {FilterButton} from '../../../../../libs/shared/ui/src/components/filters/filterButton';

/*
 * Props.
 */

export interface SearchHintItemPillProps {
  isActive: boolean;
  isDisabled: boolean;
  isHovered?: boolean;
  interactionId?: string;

  onClick?: () => void;
}

/*
 * Component.
 */

export const SearchHintItemPill: FC<PropsWithChildren<SearchHintItemPillProps>> = (props) => {
  const {onClick, isHovered, isActive, interactionId, children} = props;

  // We're only passing `isHovered` in case we're using the pill as a dropdown button.
  const isDropdown = !isUndefined(isHovered);

  return (
    <FilterButton
      isActive={isActive}
      onClick={onClick}
      hasForcedHover={isHovered}
      hasChevron={isDropdown}
      interactionId={interactionId}
    >
      {children}
    </FilterButton>
  );
};

export interface SearchHintItemPillTitleProps {
  title: string;
  icon?: ReactNode;
}

const FilterContentWrapperDiv = styled.div`
  display: grid;
  grid-auto-flow: column;
  grid-template-columns: max-content max-content;
  grid-gap: 8px;
  align-items: center;
`;

export const SearchHintItemPillTitle: FC<SearchHintItemPillTitleProps> = (props) => {
  const {title, icon} = props;

  if (!icon) {
    return <>{title}</>;
  }

  return (
    <FilterContentWrapperDiv>
      {icon}
      {title}
    </FilterContentWrapperDiv>
  );
};
